// @ts-nocheck
import {isDrawPassed} from "../../../../utils/timeUtils";

export const createTimeSlots = draws => {
  if (!draws || draws.length === 0) return [];

  return draws.map(draw => {
    const timeWithoutAmPm = removeAmPm(draw.hora);
    const isPassed = isDrawPassed(draw.hora, draw.closeTime);
    return {
      displayTime: timeWithoutAmPm,
      originalTime: draw.hora,
      isPassed,
    };
  });
};

export const removeAmPm = timeString => {
  if (!timeString) return "";
  return timeString.replace(/\s?(AM|PM|am|pm)/gi, "");
};
